import {
  fileUploadSuccessHandler,
  userInfoFetch,
} from "../../../utlis/commonFunction";
import { getAssetToken } from "../../../services/v5Api";
import { translate } from "../../../utlis/locale";
import { uploadToSignedUrl } from "../../../utlis/uploadToSignedUrl";
import { notifyMeasurementUploadToast } from "./measurementUploadNotifications";
import { getMeasurementVideoFileName } from "./measurementVideoFileName";
import { getModuleName } from "../../../utlis/measurementModuleLabels";

const getSubModuleIds = (moduleInfo, urlPath = window.location.pathname) => {
  if (Number(moduleInfo?.moduleId) !== 5) return null;
  if (urlPath === "/rom-left-flexion") return [100];
  if (urlPath === "/rom-left-extension") return [200];
  if (urlPath === "/rom-right-flexion") return [300];
  if (urlPath === "/rom-right-extension") return [400];
  return null;
};

const getTokenPayload = (response) => response?.data || response || {};

export const startMeasurementVideoUpload = ({
  file,
  moduleInfo,
  userId = userInfoFetch()?.id,
  urlPath = window.location.pathname,
  // Prod_US uploads both videos on its own upload screen, which shows its own progress.
  notify = true,
}) => {
  const toast = (notification) => {
    if (notify) notifyMeasurementUploadToast(notification);
  };
  if (!file || !moduleInfo || !userId) {
    toast({
      severity: "error",
      message: translate("videoUpload", "bg_upload_no_start"),
    });
    return Promise.resolve(null);
  }

  // Capture before the first await: navigation may change the selected person
  // and the session queue while this upload is still running.
  const uploadModule = { ...moduleInfo, moduleId: Number(moduleInfo.moduleId) };
  const subModuleIds = getSubModuleIds(uploadModule, urlPath);

  const uploadModuleName = () =>
    getModuleName(uploadModule) || translate("testModule", "measurement_video");

  return (async () => {
    try {
      const tokenResponse = await getAssetToken(
        getMeasurementVideoFileName(uploadModule, urlPath),
        uploadModule.moduleId,
        userId,
      );
      const tokenPayload = getTokenPayload(tokenResponse);
      const uploadUrl = tokenPayload.uploadUrl;
      const blobPath = tokenPayload.blobPath;

      if (!uploadUrl || !blobPath) {
        throw new Error("Failed to retrieve upload URL");
      }

      // Share the storage adapter with the other measurement upload flows.
      await uploadToSignedUrl(tokenPayload, file);

      const response = await fileUploadSuccessHandler(
        userId,
        uploadModule.moduleId,
        blobPath,
        subModuleIds,
      );

      toast({
        severity: "success",
        message: translate("videoUpload", "bg_upload_success", {
          module: uploadModuleName(),
        }),
      });

      return response;
    } catch (error) {
      console.error("Measurement video upload failed", error);
      toast({
        severity: "error",
        message: translate("videoUpload", "bg_upload_fails", {
          module: uploadModuleName(),
        }),
      });
      return null;
    }
  })();
};
